<script setup>
import {useGlobalStore} from '@/store'
import { computed, ref } from 'vue'
import CustomAlert from '@/components/CustomAlert.vue'

const showFileUploadMaxSizeAlert = ref(false)
const fileInput = ref(null)
const globalStore = useGlobalStore()
const files = computed(() => {
  return globalStore.stepOne.files ? globalStore.stepOne.files : []
})
function handleFileUpload (event) {
  const selectedFiles = event.target.files
  const maxSize = 5 * 1024 * 1024 // 5 MB in bytes
  let valid = true

  for (let i = 0; i < selectedFiles.length; i++) {
    if (selectedFiles[i].size > maxSize) {
      valid = false
      showFileUploadMaxSizeAlert.value = true
      break
    }
  }

  if (valid) {
    globalStore.setStepOneUploadedFiles(selectedFiles)
  } else {
    fileInput.value.value = ''
  }
}

function closeAlert() {
  showFileUploadMaxSizeAlert.value = false
}

function selectFiles () {
  fileInput.value.click()
}
</script>

<template>
  <CustomAlert :show="showFileUploadMaxSizeAlert" :message="$t('stepOne.fileUploadMaxSizeWarning')" @close="closeAlert" />
  <div class="form-group">
    <div class="input" :class="{'-empty-but-required': files.length === 0}">
      <!-- Custom file input button -->
      <button type="button" class="reward-campaign-invoice-upload-btn" @click="selectFiles">{{ $t('stepOne.invoiceUploadButtonText') }}</button>
      <!-- Hidden file input -->
      <input style="position: absolute; left: -9999px;" ref="fileInput" @change="handleFileUpload" required="required" id="reward-campaign-invoice-upload" accept="application/pdf,image/jpeg,image/png" type="file" class="-filled-style" name="invoice_upload" multiple />
      <div class="input-background">
        <label class="control-label" for="reward-campaign-invoice-upload">{{ $t('stepOne.invoiceUploadLabel') }}</label>
      </div>
    </div>
  </div>
  <!-- Display selected file count -->
  <p v-if="files" class="reward-campaign-invoice-uploaded-files-count">{{ $t('stepOne.invoiceUploadCounterText') }}: {{ files.length }}</p>

  <!-- Display selected file names -->
  <ul class="reward-campaign-invoice-uploaded-files" v-if="files">
    <li v-for="file in files" :key="file.name">
      <span>{{ file.name }}</span>
      <span @click="globalStore.removeFileByName(file.name)" class="icon-close-before"></span>
    </li>
  </ul>
</template>
